import Repository from "../Repository";

const resource = "/export";
export default {
    generateJCA() {
        return Repository.get(`${resource}/jca`);
    },
}